<template>
  <div class="wallet-header">
    <b-container fluid="xl">
      <div class="d-flex flex-column flex-md-row align-items-md-start">
        <div class="avatar flex-shrink-0">
          <img :src="walletData?.user?.jersey" alt="Profile Picture" />
        </div>

        <div class="d-fle flex-column flex-grow-1">
          <div
            class="d-flex flex-column flex-sm-row justify-content-between align-items-center mb-3"
          >
            <h2 class="username">
              <span class="country-flag">
                <img
                  v-if="walletData?.user?.countryFlag"
                  :src="walletData?.user?.countryFlag"
                  alt="flag"
                />
              </span>
              {{ walletData?.user?.name || "User" }}
            </h2>

            <template v-if="walletData && !isLoading">
              <b-badge
                v-if="walletData?.user?.verificationStatus === 'pending'"
                pill
                variant="warning"
              >
                <i class="bi bi-info-circle-fill"></i>
                <span>Verification in progress</span>
              </b-badge>

              <b-badge
                v-else-if="walletData?.user?.verificationStatus === 'rejected'"
                pill
                variant="danger"
              >
                <img src="/assets/images/wallet/xsign.png" alt="icon" />
                <span>Rejected</span>
              </b-badge>

              <b-badge
                v-else-if="walletData?.user?.verified"
                pill
                variant="success"
              >
                <img src="/assets/images/wallet/verified.png" alt="icon" />
                <span>verified</span>
              </b-badge>

              <b-badge v-else pill variant="danger">
                <img src="/assets/images/wallet/xsign.png" alt="icon" />
                <span>unverified</span>
              </b-badge>
            </template>
          </div>

          <div
            class="d-flex flex-column flex-md-row align-items-md-center bg-white p-4 mb-4"
          >
            <div class="d-flex flex-column">
              <strong class="total-label">Total Balance</strong>
              <span class="balance">
                {{ walletData?.walletData?.balance || "0.000000" }}
                {{ walletData?.walletData?.currency || "BTC" }}
              </span>

              <span class="consumed d-none">
                = ${{ formatUSD(walletData?.walletData?.balanceUSD) }} USD
              </span>
            </div>

            <div class="user-action">
              <slot name="action-button">
                <b-button
                  variant="warning"
                  v-if="walletData?.user?.verificationStatus === 'unverified'"
                  @click="$router.push('/wallet/account-verification')"
                >
                  Verify Account
                </b-button>

                <b-button
                  variant="warning"
                  v-if="walletData?.user?.verificationStatus === 'rejected'"
                  @click="$router.push('/wallet/account-verification')"
                >
                  Reverify Account
                </b-button>

                <b-button
                  variant="warning"
                  class="fw-bold wallet-btn"
                  v-if="walletData?.user?.verificationStatus === 'approved'"
                  @click="$router.push('/wallet/withdrawal-request')"
                >
                  Withdraw
                </b-button>
              </slot>
            </div>
          </div>

          <div class="data-time d-flex">
            <span>Last updated:</span>

            <span>{{ walletData?.walletData?.lastUpdated }}</span>
          </div>
        </div>
      </div>
    </b-container>
  </div>
</template>

<script>
export default {
  name: "WalletHeader",
  props: {
    walletData: {
      type: Object,
      default: () => null,
    },
    isLoading: {
      type: Boolean,
      default: false,
    },
  },
  methods: {
    formatUSD(value) {
      return parseFloat(value || 0).toFixed(2);
    },
  },
};
</script>

<style scoped>
.wallet-header {
  background-color: #23292e;
  padding: 3rem 0;
  position: relative;
}

.wallet-header .container-xl {
  margin: 0 auto;
  max-width: 1750px;
  padding: 0 4%;
}

.wallet-header .avatar {
  align-items: center;
  border-radius: 50%;
  border: 3px solid #373f45;
  display: inline-flex;
  height: 136px;
  justify-content: center;
  margin-right: 3rem;
  overflow: hidden;
  padding: 0.25rem;
  width: 136px;
}

.wallet-header .avatar img {
  height: auto;
  width: 114px;
}

.wallet-header .country-flag {
  align-items: center;
  border-radius: 4px;
  display: inline-flex;
  height: 25px;
  margin-right: 1rem;
  overflow: hidden;
}

.wallet-header .country-flag img {
  max-width: 42px;
}

.wallet-header .username {
  align-items: center;
  color: #ffffff;
  display: inline-flex;
  font-size: 1.5rem;
  font-weight: 500;
  margin-right: 1.5rem;
}

.wallet-header .total-label {
  font-size: 1rem;
  font-weight: 600;
  margin-bottom: 0.75rem;
}

.wallet-header .balance {
  color: #000000;
  font-size: 40px;
  font-weight: 700;
  line-height: 30px;
  margin-bottom: 1.25rem;
}

.wallet-header .consumed {
  color: #000000;
  font-size: 16px;
  font-weight: 300;
}

.wallet-header .user-action {
  margin-left: auto;
}

.wallet-header .data-time {
  color: #ffffff;
}

/* Badge Commen CSS */
.badge {
  align-items: center;
  display: inline-flex;
  font-size: 1rem;
  font-weight: 700;
  line-height: 24px;
  padding: 0.375rem 1rem;
  text-transform: capitalize;
}

.badge img {
  max-width: 1rem;
}

.badge > i,
.badge img {
  margin-right: 10px;
}

.badge-warning {
  background: rgba(252, 185, 19, 0.3);
  border: 1px solid #fcb913;
  color: #fcb913;
}

.badge-danger {
  background: rgba(243, 71, 33, 0.3);
  border: 1px solid #f34721;
  color: #f34721;
}

.badge-success {
  background: rgba(156, 240, 60, 0.29);
  border: 1px solid #9cf03c;
  color: #9cf03c;
}

/* Button CSS */
.btn {
  align-items: center;
  display: inline-flex;
  font-size: 1.25rem;
  font-weight: 500;
  justify-content: center;
  margin: 0;
  padding: 0.375rem 2rem;
  text-align: center;
  width: auto;
  color: #000000;
  border-radius: 0;
  box-shadow: none;
  line-height: 32px;
}

.btn-warning {
  background-color: #fcb913;
}

@media (max-width: 992px) {
  .wallet-header .total-label {
    margin-bottom: 0.25rem;
  }

  .wallet-header .balance {
    font-size: 1.5rem;
    margin-bottom: 0.5rem;
  }

  .btn {
    font-size: 1rem;
    padding: 0.25rem 1rem;
  }
}

@media (max-width: 768px) {
  .wallet-header {
    padding: 1.5rem 0;
  }

  .wallet-header .avatar {
    height: 100px;
    margin: 0 auto;
    width: 100px;
  }

  .wallet-header .username {
    font-size: 1.25rem;
    margin: 1rem 0;
  }

  .wallet-header .user-action {
    margin-left: 0;
    margin-top: 1rem;
  }

  .badge {
    line-height: 20px;
    padding: 0.25rem 2rem;
  }

  .wallet-header .user-action .btn {
    width: 100%;
  }
}
</style>
